// Filters.jsx
import React from "react";

/**
 * Composant générique de filtre
 * values: valeur actuelle
 * valuesList: liste des options
 * handleChange: callback onChange
 * ids: id HTML du select
 * label: texte du label
 */
export function Filters({ label, values, valuesList, handleChange, ids }) {
  return (
    <div className="flex items-center space-x-2">
      <label
        htmlFor={ids}
        className="text-md font-semibold text-gray-700 dark:text-gray-300"
      >
        {label}:
      </label>
      <select
        id={ids}
        className="w-48 px-1 py-1 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400 text-gray-700 bg-white transition-all"
        value={values}
        onChange={handleChange}
      >
        <option value="">Tous</option>
        {valuesList.map((v) => (
          <option key={v} value={v}>
            {v}
          </option>
        ))}
      </select>
    </div>
  );
}
